import { render, staticRenderFns } from "./AuthComplete.vue?vue&type=template&id=06b0411b&scoped=true&"
import script from "./AuthComplete.vue?vue&type=script&lang=js&"
export * from "./AuthComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b0411b",
  null
  
)

export default component.exports